import React from 'react';
import {Header, Breadcrumb, Container,Loader, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio, Popup, Icon} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import Tabla from "../common/ManageTabla";
import { DatePicker, Space } from 'antd';
import moment from 'moment';
import locale from 'antd/es/date-picker/locale/es_ES';
//import "antd/dist/antd.css";
const dateFormat = 'DD/MM/YYYY';


/*

                     <Form.Field required>
                            <label>{strings?strings["fechaPago"]:""}</label>  
                            <DatePicker bordered={false}
                                    defaultValue={moment(datos.fechaPresentacion, dateFormat)}    
                                    onChange={(dates, dateStrings)=>fechas(dates, dateStrings)} 
                                    locale={locale} 
                                    size="large" 
                                    value={moment(datos.fechaPresentacion, dateFormat)}
                                    allowClear={false}
                                    format={dateFormat} />
                        </Form.Field>
*/


const ModuloForm=({ id, color, archivos, form, onSave,onChange, tagCombo, 
                   headersTablaContenidos, camposTablaContenidos, validacionesTablaContenidos,tipoTablaContenidos,
                   contenidoCombo,contenidoComboTipo, ajaxCallInProgress, datos, 
                   infoActions, errors={}, strings, permisos, user,comboInstructor, fechas, onBuscar, goBack,  test })=>{
    

	return (
        <Container>
         
        
        
          <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
          		<Loader size='big' inline content={strings?strings["Procesando"]:""}/>
          </Dimmer>

				<Header     dividing>             
					<Header.Content>{strings?strings["Modulo"]:""}</Header.Content>
				</Header>
			<Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form  >          
                            <Form.Field  required  error={errors.titulo}>            
                              <label  >{strings?strings["titulo"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["titulo"]:""} 
                                    name="titulo"
                                    onChange={onChange}
                                    value={datos.titulo}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.descripcion}>            
                              <label  >{strings?strings["descripcion"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["descripcion"]:""} 
                                    name="descripcion"
                                    onChange={onChange}
                                    value={datos.descripcion}
                                    icon='edit'/>
                            </Form.Field>
                                            
        
                            <Form.Field  required  error={errors.prefijo}>            
                                          <label  >{strings?strings["prefijo"]:""}</label>
                                          <Input 
                                                placeholder={strings?strings["prefijo"]:""} 
                                                name="prefijo"
                                                onChange={onChange}
                                                value={datos.prefijo}
                                                icon='edit'/>
                                        </Form.Field>

                                        <Button  color="black"
                                            onClick={onBuscar}>{strings?strings["buscar"]:""}
                                         </Button>
                       
        
                            <Form.Field  required  error={errors.imagen}>
                              <label  >{strings?strings["imagen"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["imagen"]:""} 
                                    name="imagen"
									 fluid 
                                    search 
                                    selection
                                    
                                    onChange={onChange}
                                    value={datos.imagen}
                                    options={archivos}/>
                            </Form.Field>
        
        
                        {datos.id?
        
                        <>
                            <Form.Field  required  error={errors.idsContenidos}>
                                    <label  >{strings?strings["idsContenidos"]:""}</label>
                            </Form.Field>
                            <Grid>
                                    <Grid.Row>
                                    <Grid.Column  width={16}>    
                                        <Link to={"/contenido/"}> 
                                         <Popup
                                            trigger={<Icon  name='add' link   size="large"  color="tela" ></Icon>}
                                            content='Agregar nuevo contenido'

                                          />
                                         </Link>
                                        </Grid.Column>
                                    </Grid.Row>             
                                 </Grid>         
        
                      
        
                                <Form.Field  required  error={errors.idsContenidos}>    
                                    <Tabla 
                                        tipoTablaModulos={tipoTablaContenidos}
                                        combo={contenidoCombo}
                                        comboInstructor={comboInstructor}  
                                        infoActions={infoActions}
                                        play={true}
                                        user={user}
                                        nombre="idsContenidos"
                                        headers={headersTablaContenidos}
                                        campos={camposTablaContenidos}
                                        validaciones={validacionesTablaContenidos}
                                        contenidoComboTipo={contenidoComboTipo}
                                        test={test}
                                    />  
                                </Form.Field>
                            </>                   
                           :
                            ""
                            }
                                            
                            <Form.Field  required  error={errors.idsTags}>
                              <label  >{strings?strings["idsTags"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["idsTags"]:""} 
                                    name="idsTags"
									 fluid 
                                    search 
                                    selection
                                    multiple
                                    onChange={onChange}
                                    value={datos.idsTags}
                                    options={tagCombo}/>
                            </Form.Field>
                                                                        
                            <Divider hidden/>
							  <Grid centered>
                            <Button.Group  >
                                
                                    <Button  onClick={goBack}
										>{strings?strings["regresar"]:""}</Button>
                                
                                <Button.Or text=" "></Button.Or>
                                <Button  color="black"
                                    onClick={onSave}>{strings?strings["guardar"]:""}
								 </Button>
                              </Button.Group>
                            </Grid>
                           <br/>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                
            
            </Grid>
        
        </Container>
	);
};



export default ModuloForm;